<div class="main-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">

  <a *ngIf="!deviceSearchAddPageTitle" [routerLink]="myDeviceRoute" class="link" [gtmClick]="getViewLabel('Devices_Breadcrumbs_Title')" [gtmLinkURL]="myDeviceRoute"><adp-label labelKey="Devices_Breadcrumbs_Title"></adp-label></a>
  <a *ngIf="deviceSearchAddPageTitle" href="{{myDeviceRoute}}"  class="link" [gtmClick]="getViewLabel('Devices_Breadcrumbs_Title')" [gtmLinkURL]="myDeviceRoute"><adp-label labelKey="Devices_Breadcrumbs_Title"></adp-label></a>

  <ng-container *ngIf="!deviceSearchAddPageTitle">
    <ng-container *ngIf="selectedDevice != null">
      <div>/</div>
      <a *ngIf="(deviceContentPageTitle ?? '').length > 0" [routerLink]="deviceDetailsRoute" fxFlex="0 1 auto" class="link device-link" [title]="selectedDevice | deviceDisplayName"
        [gtmClick]="selectedDevice | deviceDisplayName" [gtmLinkURL]="deviceDetailsRoute">{{selectedDevice | deviceDisplayName}}</a>
      <div *ngIf="(deviceContentPageTitle ?? '').length < 1" class="device-link" fxFlex="0 1 auto" [title]="selectedDevice | deviceDisplayName">{{selectedDevice | deviceDisplayName}}</div>
    </ng-container>
    <ng-container *ngIf="(deviceContentPageTitle ?? '').length > 0">
      <div>/</div>
      <div>{{deviceContentPageTitle}}</div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isSPOEEnabled && ((deviceSearchAddPageTitle ?? '').length > 0)">
    <div>/</div>
    <div>{{deviceSearchAddPageTitle}}</div>
  </ng-container>


</div>
